module.exports = __webpack_public_path__ + "img/mail__kws.cf44b7f1.svg";